
//#region Type definitions

/**
 * @typedef {object} SessionOptions
 * @property {string} [redirectPath] 
 * @property {string} [abortPath]
 */

/**
 * @callback SessionFunction
 * @param {SessionOptions} [options] 
 */

/**
 * @typedef {object} Token
 * @property {string} accessToken
 * @property {string} expiresAt ex: 2019-04-30T12:13:14.123456Z
 */

/**
 * Called with an unexpired token
 * @callback TokenCallback
 * @param {Error | null} [error] 
 * @param {Token | null} [token] 
 */

 /**
 * @callback TokenFunction
 * @param {TokenCallback} cb
 */

/**
 * @typedef {object} Session
 * @property {SessionFunction} login redirects client to login page
 * @property {SessionFunction} logout redirects client to logout page
 * @property {TokenFunction} token
 */

/**
 * @typedef {object} User
 * @property {string} name 
 * @property {string} sessionState
 * @property {string} subject
 */

 /**
 * Called with unexpired token
 * @callback ConnectCallback
 * @param {User | false} user
 * @param {Session} session 
 */

 //#endregion

/**
 * Connect takes a callback that will be called after retrieving the users session
 * @param {ConnectCallback} callback Function that will be called
 * @example
 * connect((user, session) => {
 *   if (user) {
 *     console.log(`${user.name} is logged in`)
 *   } else {
 *     session.login({abortPath: '%2Fminside'})
 *   }
 * })
 */
export function connect(callback) {
  const key = 'onLoginReady';
  // Add callback queue placeholder if needed
  if (window[key] === undefined) {
    window[key] = function() {
      (window[key].q = window[key].q || []).push(arguments);
    };
  }

  // load script if needed
  loadOnce('/logginn.js');

  // add callback
  window[key](callback);
}

/**
 * loadOnce loads the given script IFF it is not already present in the DOM.
 * @param {string} src URL for script
 * @returns {undefined}
 */
function loadOnce(src) {
  const hasScript = document.querySelector(`script[src="${src}"]`);

  if (hasScript){
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = src;

  document.head.appendChild(script);
}
